import { create } from 'zustand';

/**
 * UI Store - Global UI state
 * Manages theme, modals, toasts, navigation, and other UI concerns
 */
export const useUIStore = create((set, get) => ({
  // Theme
  theme: 'dark',
  
  // Modals
  activeModal: null,
  modalData: null,
  
  // Toasts
  toasts: [],
  
  // Navigation
  previousRoute: null,
  isNavigating: false,
  
  // Mobile
  isMobileMenuOpen: false,
  
  // Loading states
  globalLoading: false,
  loadingMessage: '',

  // Actions
  setTheme: (theme) => set({ theme }),
  
  openModal: (modalId, data = null) => set({
    activeModal: modalId,
    modalData: data,
  }),
  
  closeModal: () => set({
    activeModal: null,
    modalData: null,
  }),
  
  addToast: (toast) => {
    const id = Date.now().toString();
    const newToast = {
      id,
      type: 'info',
      duration: 3000,
      ...toast,
    };
    
    set((state) => ({
      toasts: [...state.toasts, newToast],
    }));
    
    // Auto-remove toast
    setTimeout(() => {
      get().removeToast(id);
    }, newToast.duration);
    
    return id;
  },
  
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter((t) => t.id !== id),
  })),
  
  showSuccess: (message) => get().addToast({ type: 'success', message }),
  showError: (message) => get().addToast({ type: 'error', message }),
  showInfo: (message) => get().addToast({ type: 'info', message }),
  showWarning: (message) => get().addToast({ type: 'warning', message }),
  
  setPreviousRoute: (route) => set({ previousRoute: route }),
  
  setIsNavigating: (isNavigating) => set({ isNavigating }),
  
  toggleMobileMenu: () => set((state) => ({
    isMobileMenuOpen: !state.isMobileMenuOpen,
  })),
  
  closeMobileMenu: () => set({ isMobileMenuOpen: false }),
  
  setGlobalLoading: (loading, message = '') => set({
    globalLoading: loading,
    loadingMessage: message,
  }),
}));

export default useUIStore;
